module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "Basic-Text-Frame"
  }, [_c('p', {
    staticClass: "Normal"
  }, [_c('span', {
    staticClass: "Bold CharOverride-3"
  }, [_vm._v("T")]), _c('span', {
    staticClass: "Bold CharOverride-4"
  }, [_vm._v("he "), _c('br'), _vm._v("Best New "), _c('br'), _vm._v("True Crime "), _c('br'), _vm._v("Stories")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-3"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("Unsolved "), _c('br'), _vm._v("Crimes "), _c('br'), _vm._v("& Mysteries")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-4"
  }, [_c('span', {
    staticClass: "Bold CharOverride-6"
  }, [_vm._v("Mitzi Szereto")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-5"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/MangoPublishingLogo(grayscale).jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-6"
  }, [_c('span', {
    staticClass: "CharOverride-8"
  }, [_vm._v("Coral Gables")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-32718552","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/TheBestNewTrueCrimeStories-3.vue
// module id = 66
// module chunks = 0